import styled from 'styled-components'

export const Container = styled.div<{ isOpen: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  max-width: 100dvw;

  transition-property: opacity, z-index;
  transition-duration: 200ms;
  transition-timing-function: ease-in;

  ${({ isOpen }) => ({
    opacity: isOpen ? 1 : 0,
    zIndex: isOpen ? 9999 : -9999,
  })}
`
